
<template>
  <transition name="fade-slide">
    <div v-if="visible" :class="['snackbar', type]">
      {{ message }}
    </div>
  </transition>
</template>

<script setup>
import { ref, watch, onBeforeUnmount } from 'vue';

const props = defineProps({
  message: String,
  type: { type: String, default: 'success' },
  show: Boolean
});

const visible = ref(false);
let timer = null;

watch(() => props.show, (val) => {
  if (val) {
    visible.value = true;
    clearTimeout(timer);
    timer = setTimeout(() => {
      visible.value = false;
    }, 3000);
  }
});

onBeforeUnmount(() => {
  clearTimeout(timer);
});
</script>

<style scoped>
.snackbar {
  position: fixed;
  bottom: 30px;
  left: 50%;

  transform: translateX(-50%);

  padding: 14px 24px;

  border-radius: 14px;

  color: white;
  font-family: "Eastman-Medium", sans-serif;

  z-index: 9999;

  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);

  font-size: 14px;

  max-width: 80%;
  text-align: center;

  backdrop-filter: blur(10px);
}

.snackbar.success {
  background-color: #3D956F;
}

.snackbar.error {
  background-color: #E65122;
}

/* ========= ANIMATION ========= */

.fade-slide-enter-active,
.fade-slide-leave-active {
  transition:
    opacity 0.3s ease,
    transform 0.3s ease;
}

.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(20px);
}

.fade-slide-enter-to,
.fade-slide-leave-from {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}

/* ========= MOBILE ========= */

@media (max-width: 430px) {

  .snackbar {
    bottom: 82px;

    width: calc(100% - 32px);
    max-width: none;

    padding: 14px 16px;

    font-size: 13px;
    line-height: 1.4;

    border-radius: 16px;

    text-align: center;

    box-sizing: border-box;
  }
}
</style>